if (!customElements.get('ff-products-slider-tabs')) {
  customElements.define('ff-products-slider-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('.ff-pdc-tab');
      this.ffSlider = this.querySelector('ff-slider');
      this.splideInstance = null;

      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
      });

      this.initSplideInstance();
    }

    initSplideInstance() {
      if (this.ffSlider && this.ffSlider.splide) {
        this.splideInstance = this.ffSlider.splide;
        this.loadFirstCollection();
      } else {
        setTimeout(() => this.initSplideInstance(), 100);
      }
    }

    loadFirstCollection() {
      const list = this.ffSlider.querySelector('.splide__list');
      const hasRealContent = list && list.children.length > 0 &&
        !list.querySelector('.ff-pdc-placeholder');

      if (hasRealContent) {
        this.splideInstance.refresh();
        return;
      }

      const firstTemplate = this.querySelector('template[data-collection-index="0"]');
      if (firstTemplate && this.splideInstance) {
        list.innerHTML = firstTemplate.innerHTML;
        this.splideInstance.refresh();
      }
    }

    handleTabClick(e) {
      const tab = e.currentTarget;
      const index = tab.dataset.collectionIndex;

      if (tab.classList.contains('ff-pdc-tab--active')) return;

      this.tabs.forEach(t => t.classList.remove('ff-pdc-tab--active'));
      tab.classList.add('ff-pdc-tab--active');

      const template = this.querySelector(`template[data-collection-index="${index}"]`);
      if (template && this.splideInstance) {
        const list = this.ffSlider.querySelector('.splide__list');
        list.innerHTML = template.innerHTML;

        this.splideInstance.go(0);
        this.splideInstance.refresh();
      }

      // Update "Show all" link URL
      const showAllLink = this.querySelector('[data-show-all-link]');
      if (showAllLink && tab.dataset.collectionUrl) {
        showAllLink.href = tab.dataset.collectionUrl;
      }
    }
  });
}